import { Box } from '@pco/atoms/Box';
import { Typography } from '@pco/atoms/Typography';

export const CartDrawerHeader: React.FC<{ title: string }> = ({ title }) => (
	<Box as="header" flexDirection="column" alignItems="flex-start">
		<Typography as="div" $weight="semibold" _size="body16">
			{title}
		</Typography>
	</Box>
);
